import SectionSkeleton from "../../../components/ui/SectionSkeleton"
import { Box, Container, Link, Stack, Typography } from "@mui/material"
import { Link as NavLink } from "react-router-dom"
import { Fragment, lazy, Suspense } from "react"
import Images from "../../../assets/js/Images"
import { obj1, obj2, obj3, obj4, obj5, obj6, obj7, obj8, obj9, obj10, obj11, obj12 } from "./data"

const TopBannerA = lazy(() => import("../../../components/common/TopBannerA"))

function TermAndCondintion() {
  const sections = [obj1, obj2, obj3, obj4, obj5, obj6, obj7, obj8, obj9, obj10, obj11, obj12]

  return (
    <Fragment>
      <Suspense fallback={<SectionSkeleton />}>
        <TopBannerA
          heading="Terms & Conditions"
          currentPage="Terms & Conditions"
          bannerImg={Images?.privacyPolicy}
        />
      </Suspense>

      <Box sx={{ py: 6 }}>
        <Container maxWidth={false} fixed>
          <Stack sx={{ maxWidth: "1100px", mx: "auto" }} spacing={4}>
            <Box>
              <Typography
                mb={2}
                fontSize={28}
                fontWeight="700"
                color="other.color1"
              >Terms & Conditions for InnerPal.com
              </Typography>
              <Typography
                mb={3}
                fontWeight="500"
                color="other.color1"
              ><b>Effective Date: </b>07/31/2026
              </Typography>
              <Typography
                fontSize={18}
                color="other.color1"
              >Welcome to InnerPal.com ("we," "us," "our"). Before starting your emotional wellness journey with us, please read these Terms & Conditions carefully. They outline your rights, responsibilities, and key information regarding your use of our platform.
              </Typography>
            </Box>

            {sections.map((obj, i) => (
              <Box key={i}>
                <Typography
                  mb={2}
                  fontSize={24}
                  component="h4"
                  fontWeight="700"
                  color="other.color1"
                >{obj?.title}
                </Typography>
                {obj?.subTitle && (
                  <Typography
                    mb={2}
                    fontWeight="500"
                    color="other.color1"
                  >{obj?.subTitle}
                  </Typography>
                )}
                {obj?.list && (
                  <Box component="ul">
                    {obj.list.map((item, j) => (
                      <Typography
                        mb={1}
                        key={j}
                        component="li"
                        color="other.color2"
                      >
                        {item?.key && (
                          <strong>{item?.key} </strong>
                        )}
                        {item?.summary}
                      </Typography>
                    ))}
                  </Box>
                )}
                {obj?.otherTitle && (
                  <Typography
                    mt={1}
                    fontWeight="500"
                    color="other.color1"
                  >{obj?.otherTitle}
                  </Typography>
                )}
              </Box>
            ))}

            <Box>
              <Typography
                mb={2}
                fontSize={24}
                component="h4"
                fontWeight="700"
                color="other.color1"
              >📬 Need Assistance?
              </Typography>
              <Typography
                mb={1}
                color="other.color2"
              >Our support team is always available to help you with any questions or account inquiries.
              </Typography>
              <Typography
                fontWeight="600"
                color="other.color1"
              >Email: <Link
                component={NavLink}
                fontWeight="500"
                to="mailto:support@innerpal.com"
              >support@innerpal.com
                </Link>
              </Typography>
            </Box>
          </Stack>
        </Container>
      </Box>
    </Fragment>
  )
}

export default TermAndCondintion